var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-container w-100"},[_c('SectionTitle',{attrs:{"title":"KPI Overview"}}),_c('KpiComparisonTable',{attrs:{"kpiValues":_vm.sessionValues,"kpiComparison":_vm.sessionKpiComparison,"valueLabel":"match average","peakSpeedLabel":"match maximum"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }